function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectionAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.061 11.719 C 13.871 11.722 13.683 11.757 13.505 11.824 L 11.612 10.274 C 11.658 10.105 11.691 9.931 11.691 9.745 C 11.691 8.65 10.812 7.771 9.717 7.771 C 8.622 7.771 7.743 8.65 7.743 9.745 C 7.743 10.059 7.821 10.35 7.949 10.611 L 5.652 13.327 C 5.559 13.31 5.466 13.302 5.373 13.299 C 5.232 13.299 5.098 13.323 4.969 13.357 L 2.944 11.334 C 2.98 11.205 3.004 11.071 3.004 10.93 C 3.004 10.055 2.299 9.351 1.424 9.351 C 0.549 9.351 -0.155 10.055 -0.155 10.93 C -0.155 11.806 0.549 12.51 1.424 12.51 C 1.565 12.51 1.698 12.486 1.828 12.451 L 3.852 14.476 C 3.814 14.606 3.794 14.743 3.793 14.879 C 3.793 15.754 4.497 16.458 5.373 16.458 C 6.247 16.458 6.952 15.754 6.952 14.879 C 6.952 14.691 6.914 14.516 6.855 14.35 L 9.155 11.63 C 9.336 11.682 9.521 11.719 9.717 11.719 C 10.029 11.718 10.335 11.641 10.611 11.497 L 12.507 13.048 C 12.491 13.132 12.483 13.215 12.482 13.299 C 12.482 14.174 13.186 14.879 14.061 14.879 C 14.936 14.879 15.641 14.174 15.641 13.299 C 15.641 12.423 14.936 11.719 14.061 11.719 Z",
    style: {},
    transform: "matrix(0.973197, 0.229973, -0.229973, 0.973197, 2.993543, -1.455976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17.932 1.906 H 18.908 V 5.84 H 22.842 V 6.816 H 18.908 V 10.75 H 17.932 V 6.816 H 13.998 V 5.84 H 17.932 Z",
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionAdd);
export default __webpack_public_path__ + "static/media/connection-add.9f7834cac7db00f463d1a2c96230b5ee.svg";
export { ForwardRef as ReactComponent };